import objectPath from 'object-path'
import httpClient from 'utility/httpClient.util'
import cloneDeep from 'clone-deep'
import { generateString } from 'designer/component/action/Data'
import { setResponseTable } from 'designer/component/action/Table'
import { getApi } from 'designer/component/action/Api'
import { checkCrudCondition, crud } from '../table/action/Crud'
import { genRefId } from 'designer/component/element/table/action/index'
import { onCheckCondition } from 'designer/component/action/condition/Action'

export const createRenderTableData = (deps) => {
  const {
    jsonForm,
    isUiChanged,
    formData,
    searchData,
    searchDataFromPage,
    allParams,
    tabParamActive,
    search,
    dynamicData,
    onAction,
    searchPath,
    searchString,
    tableData,
    loading,
    designContext,
    setFormData,
    setTableRefresh,
    setLoading,
  } = deps

  const loadByGET = async (action, propTable, designContextArg) => {
    let { uischema } = propTable
    let responseTotalCount
    let propTableWithTotalCount = {
      ...propTable,
      onAction: {
        ...propTable.onAction,
        setTotalCount: (totalCount) => {
          responseTotalCount = totalCount
          if (propTable.onAction.setTotalCount) {
            propTable.onAction.setTotalCount(totalCount)
          }
        },
      },
    }
    let loadData = objectPath.get(uischema, 'loadData') || {}
    let requestUrl = getApi(
      action,
      {
        ...propTableWithTotalCount,
        isTable: true,
        designContext: designContextArg,
      },
      'loadByGET',
    )
    let response = []
    if (requestUrl) {
      let { headers = [] } = action
      let config = {}
      if (headers.length > 0) {
        headers.forEach(({ key, value }) => {
          if (key) {
            objectPath.set(config, `headers.${key}`, value)
          }
        })
      }
      response = await httpClient
        .get(requestUrl, config)
        .then(({ data }) => data)
        .catch(() => [])
    }
    let tableDataResult = setResponseTable(
      response,
      action,
      propTableWithTotalCount,
      loadData,
    )
    objectPath.set(formData, uischema.key, tableDataResult)
    objectPath.set(formData, uischema.name, tableDataResult)
    setFormData(formData)

    return {
      tableData: tableDataResult,
      totalCount: responseTotalCount,
    }
  }

  return (ui) => {
    const tableColumnList = objectPath.get(ui, 'tableColumn') || []
    const elementTableColumn = tableColumnList.filter(
      ({ valueType }) => valueType === 'element',
    )
    const componentPropsData = objectPath.get(jsonForm, 'componentPropsData')
    const isRefreshTable =
      objectPath.get(isUiChanged, 'isRefreshTable') ||
      objectPath.get(componentPropsData, 'isRefreshTable')
    const designerData = objectPath.get(componentPropsData, 'data')
    let prop = {
      pagination: { page: 0, rowsPerPage: ui?.rowsPerPage },
      formData: { ...formData, ...searchData, ...searchDataFromPage },
      allParams,
      designerData,
      tabParamActive,
      componentPropsData,
      search,
      dynamicData,
      onAction,
      inputSearch: {},
      searchPath,
      searchString,
      tableData,
      isRefreshTable,
      loading,
      elementTableColumn,
      uischema: ui,
      pagination: { page: 0, rowsPerPage: ui?.rowsPerPage },
    }
    let isLoadGET = objectPath.get(ui, 'loadData.method') === 'GET'
    let isLoadApiGET = objectPath.get(ui, 'loadData.method') === 'API_CONDITION'
    if (ui?.loadData) {
      let { get, apiCondition } = ui.loadData
      if (isLoadGET && get) {
        loadByGET(get, prop, designContext).then((response = {}) => {
          setTableRefresh([
            {
              key: ui.key,
              isButton: true,
              data: response.tableData || [],
              totalCount: response.totalCount,
            },
          ])
        })
      } else if (isLoadApiGET && apiCondition) {
        let filterApi = checkCrudCondition({
          action: ui.loadData,
          designContext,
          allParams,
        })
        if (filterApi?.length > 0) {
          filterApi.forEach((getAction) => {
            loadByGET(getAction, prop, designContext).then((response = {}) => {
              setTableRefresh([
                {
                  key: ui.key,
                  isButton: true,
                  data: response.tableData || [],
                  totalCount: response.totalCount,
                },
              ])
            })
          })
        } else {
          setLoading(false)
        }
      }
    }
  }
}

export const createSelectFavorite = (deps) => {
  const {
    uischema,
    favorite,
    favoriteJsonName,
    favoriteSelectType,
    mapFieldFavorite,
    formData,
    designContext,
    allParams,
    user,
    jsonForm,
    isUiChanged,
    setFormData,
    setIsUiChanged,
    renderTableData,
    onCloseModal,
    getCurrentUi,
  } = deps

  const isAddApiAction = (action = {}) => {
    if (action.name !== 'add') return false
    if (action.action === 'api') return true
    if (action.action) return false
    return action.method && (action.endpoint || action.api || action.service)
  }

  const getCrudAction = (action = {}) => {
    let crudAction = { ...action }
    crudAction.method = crudAction.method
      ? crudAction.method.toLowerCase()
      : 'post'
    return crudAction
  }

  return () => {
    const jsonDataMap = objectPath.get(uischema, 'favorite.jsonData')
    const { jsonData } = favorite
    const isFavoriteFetch = true

    Object.keys(jsonDataMap).forEach((key) => {
      let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
      if (ui.key !== key) return
      let name = jsonDataMap[key]
      let value =
        (favoriteJsonName && objectPath.get(jsonData, favoriteJsonName)) ||
        objectPath.get(jsonData, name)
      if (value === undefined) return
      let oldValue =
        objectPath.get(formData, key) || objectPath.get(formData, name) || []
      if (['table', 'customTable'].includes(ui.tagname)) {
        let { tableAction } = ui
        let tableActionSaveType = tableAction.saveType
        if (ui.tagname === 'customTable') {
          oldValue = oldValue.filter((item) => {
            let oldRow = cloneDeep(item)
            objectPath.del(oldRow, '@genId')
            objectPath.del(oldRow, '@seq')
            objectPath.del(oldRow, 'tableData')
            let length = Object.keys(oldRow).length
            return length > 0
          })
        }
        if (tableActionSaveType === 'api' || favoriteSelectType === 'api') {
          let { action = [] } = tableAction
          let addApi = action.find((item) => isAddApiAction(item))

          let addApiCondition = action.find(
            (item) => item.name === 'add' && item.action === 'apiCondition',
          )
          value = value ? (Array.isArray(value) ? value : [value]) : []
          if (addApiCondition) {
            let addApiList = checkCrudCondition({
              action: addApiCondition,
              designContext,
              allParams,
            })
            addApiList.map((item) => {
              crud({
                action: getCrudAction(item),
                rowData: value,
                designContext,
                renderTableData,
                allParams,
                user,
                uischema: ui,
                isFavoriteFetch,
              })
            })
          } else if (addApi) {
            crud({
              action: getCrudAction(addApi),
              rowData: value,
              designContext,
              renderTableData,
              allParams,
              user,
              uischema: ui,
              isFavoriteFetch,
            })
          }
        } else {
          let newTable = []
          if (Array.isArray(value)) {
            let newValue = value.map((rowValue) => {
              let genId = generateString(10)
              let newValue = {
                [genRefId]: 'id-' + genId,
              }
              mapFieldFavorite.forEach(({ field }) => {
                let cellValue = objectPath.get(rowValue, field)
                objectPath.set(newValue, field, cellValue)
              })
              return newValue
            })
            if (Array.isArray(oldValue)) {
              newTable = [...oldValue, ...newValue]
            } else {
              newTable = newValue
            }
            objectPath.set(formData, key, newTable)
            objectPath.set(formData, name, newTable)
          }
        }
      } else {
        if (oldValue) {
          objectPath.set(formData, key, oldValue + ' ' + value)
          objectPath.set(formData, name, oldValue + ' ' + value)
        } else {
          objectPath.set(formData, key, value)
          objectPath.set(formData, name, value)
        }
      }
      objectPath.set(isUiChanged, `${key}.isRender`, true)
      onCheckCondition(designContext, formData, key, {
        isFavorite: true,
      })
    })
    setFormData(formData)
    setIsUiChanged(isUiChanged)
    onCloseModal()
  }
}
